import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { SubmissionHistory, SubmissionHistoryFilterResponse } from '../model/submission-history';
import { DIMBO_CONSTANT } from '../utils/constant';

@Injectable({
  providedIn: 'root'
})
export class VinSearchService {
  domain: string;


  constructor(private httpService: HttpService, private apiconfig: AppConfig, private http: HttpClient) {
    let apipath = '';

    apipath = this.apiconfig.apiUrl;
    this.domain = apipath + this.apiconfig.apiPath;
  }


   searchByVin(vin: string): Observable<SubmissionHistory[]> {
    
    const url = `${this.domain}${DIMBO_CONSTANT.BRANDCARE_SUBMISSION_HISTORY.replace('{vin}', encodeURIComponent(vin))}`;
    return this.httpService.get(url).pipe(
      map((response: any) => response as SubmissionHistory[])
    );

  }

  /**
   * CAP-39922 DMBR-64
   * Search submission history by physical site or user RRDI within a date range with pagination.
   * @param params - Object with physicalSite or userRrdi, startDate, endDate, page, size
   */
  searchByFilter(params: { physicalSite?: string; userRrdi?: string; startDate: string; endDate: string; page?: number; size?: number }): Observable<SubmissionHistoryFilterResponse> {
    const queryParams = new URLSearchParams();
    if (params.physicalSite) {
      queryParams.set('physicalSite', params.physicalSite);
    }
    if (params.userRrdi) {
      queryParams.set('userRrdi', params.userRrdi);
    }
    queryParams.set('startDate', params.startDate);
    queryParams.set('endDate', params.endDate);
    queryParams.set('page', String(params.page ?? 0));
    // Start: CAP-39922 DMBR-64
    queryParams.set('size', String(params.size ?? 10));
    // End: CAP-39922 DMBR-64

    const url = `${this.domain}${DIMBO_CONSTANT.BRANDCARE_SUBMISSION_HISTORY_FILTER}?${queryParams.toString()}`;
    return this.httpService.get(url).pipe(
      map((response: any) => response as SubmissionHistoryFilterResponse)
    );
  }
}
